module.exports = __webpack_public_path__ + "img/foto_UNAM.da9b293b.png";